export const validateVariantList = (variants, type) => {
    if (variants.length === 0) {
        return 'at least one variant is required';
    }

    for (let i = 0; i < variants.length; i++) {
        const errorMsg = validateVariant(variants[i], type);
        if (errorMsg !== null) {
            return errorMsg;
        }
    }

    return null;
};

const validateVariant = (variant, type) => {
    if (variant.originalPrice && isNaN(variant.originalPrice)) {
        return 'original price must be a number';
    }

    if (variant.currentPrice && isNaN(variant.currentPrice)) {
        return 'current price must be a number';
    }

    return null;
};
